import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { House, Clock, Calendar, Users, Wrench } from 'lucide-react';
import { useRoleContext } from '../../context/RoleContext';
const NavContainer = styled.nav`
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 100;
    overflow-x: auto;
  }
`;

const DesktopNav = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileNav = styled.ul`
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-around;
  }
`;

const NavItem = styled.li`
  margin: 0;
  padding: 0;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StyledNavLink = styled(NavLink)`
  display: block;
  padding: 1rem;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    background-color: #f0f0f0;
  }

  &:focus {
    outline: none;
  }
    
  &.active {
    color: var(--primary-green);
    border-bottom: 3px solid var(--primary-green);
  }
  
  @media (max-width: 768px) {
    padding: 0.8rem 0.5rem;
    text-align: center;
    font-size: 0.8rem;
    
    &.active {
      border-bottom: none;
      color: var(--primary-green);
    }
    
    &:focus {
      outline: none;
    }
  }
`;

const MobileNavLink = styled(StyledNavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8rem;
  padding: 0.7rem 0.5rem;
  width: 100%;
`;

const Icon = styled.span`
  font-size: 1.2rem;
  margin-bottom: 0.2rem;
`;

const Navigation = () => {
  const [isMobile] = useState(window.innerWidth <= 768);
  const { isManager, isAuthenticated } = useRoleContext();

  return (
    <NavContainer>
      <DesktopNav>
        <NavItem>
          <StyledNavLink to="/dashboard">Dashboard</StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/events">Events</StyledNavLink>
        </NavItem>
        <NavItem>
          <StyledNavLink to="/time-tracking">Time Tracking</StyledNavLink>
        </NavItem>
        {isManager && (
          <NavItem>
            <StyledNavLink to="/employees">Employees</StyledNavLink>
          </NavItem>
        )}
        {isManager && (
          <NavItem>
            <StyledNavLink to="/equipment">Equipment</StyledNavLink>
          </NavItem>
        )}
        {/* <NavItem>
          <StyledNavLink to="/handbook">Handbook</StyledNavLink>
        </NavItem> */}
      </DesktopNav>
      
      <MobileNav>
        <NavItem>
          <MobileNavLink to="/dashboard">
            <House size={20} /> 
            Dashboard
          </MobileNavLink>
        </NavItem>
        <NavItem>
          <MobileNavLink to="/events">
            <Calendar size={20} />
            Events
          </MobileNavLink>
        </NavItem>
        <NavItem> 
          <MobileNavLink to="/time-tracking">
            <Clock size={20} />
            Time
          </MobileNavLink>
        </NavItem>
        {isManager && (
          <NavItem>
            <MobileNavLink to="/employees">
              <Users size={20} />
              Employees
            </MobileNavLink>
          </NavItem>
        )}
        {isManager && (
          <NavItem>
            <MobileNavLink to="/equipment">
              <Wrench size={20} />
              Equipment
            </MobileNavLink>
          </NavItem>
        )}
      </MobileNav>
    </NavContainer>
  );
};

export default Navigation; 